var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._m(0),_vm._v(" "),_c('change-password')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('h2',{staticClass:"title font-black uppercase text-neutral-900"},[_vm._v("Account Details")])])
}]

export { render, staticRenderFns }